<template>
  <div class="v-home-layout">
    <Home />
  </div>
</template>

<script>
import Home from "@/components/pages/home/index.vue";

export default {
  name: "HomeLayout",
  components: {
    Home
  }
};
</script>

<style lang="scss">
@import "./home-layout.scss";
</style>
